const awsConfig = {
  Auth: {
    Cognito: {
      identityPoolId: 'eu-west-1:f3470cae-d2c0-423a-964e-3781e78afacf', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'eu-west-1', // REQUIRED - Amazon Cognito Region
      userPoolId: 'eu-west-1_WdDbjt2mI', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolClientId: '7td2n3h3n2fd7gjs5ohrv539gj', //OPTIONAL - Amazon Cognito Web Client ID
    }
  },
  Storage: {
    AWSS3: {
      bucket: 'production-referencecatalog-s3-bucket',
      region: 'eu-west-1', //OPTIONAL -  Amazon service region
    }
  },
  region: 'eu-west-1',
};
export default awsConfig;